import { ProductSlug, asProductSlug } from 'domain/types';

import { protocolsHosts } from './protocolsConfig';

export const getSlugByProtocolsHost = (host: string | null): ProductSlug | null => {
  const protocol = protocolsHosts.find(item => item.host === host);

  return protocol ? asProductSlug(protocol.slug) : null;
};
